export const uploadImage = {
    props: {
        i18n: Object,
    },
    methods: {
        addImage(
            event,
            uploaded,
            arr = false,
            callback = false,
            maxSize = false
        ) {
            if (!event.target.files[0]) {
                return;
            }
            this.instanceLoader = true;

            let self = this;
            maxSize = maxSize * 1024 || 10240000;

            // TODO: костыль; без него в попапе FirstLogin2 ава загружается только при первом открытии попапа; если снова нажать "выбрать файл" и выбрать картинку, она не заменяется новой.
            if (uploaded == "avatar") {
                self[uploaded] = undefined;
            }

            let uploadImg = (file) => {
                return new Promise((resolve, reject) => {
                    if (file.size > maxSize) {
                        this.$modal.show("dialog", {
                            title: this.$t("mixins.warning"),
                            text:
                                this.$t("mixins.fileSize") +
                                file.name +
                                this.$t("mixins.oversized") +
                                Math.floor(maxSize / (1024 * 1024)) +
                                this.$t("mixins.mb"),
                            buttons: [{ title: this.$t("mixins.ok") }],
                        });
                        reject();
                        return;
                    }

                    let reader = new FileReader();

                    reader.onload = (e) => {
                        if (arr) {
                            let obj = {};
                            obj[uploaded] = e.target.result;
                            obj.name = file.name;
                            arr.push(obj);
                        } else {
                            self[uploaded] = e.target.result;
                        }
                        resolve();
                    };

                    reader.onerror = () => {
                        reject();
                    };

                    reader.readAsDataURL(file);
                });
            };

            let list = [];

            for (let i in event.target.files) {
                let file = event.target.files[i];

                if (file && file.type) {
                    list.push(file);
                }
            }

            let promise = Promise.all(list.map((file) => uploadImg(file)));

            promise
                .then(() => {
                    this.instanceLoader = false;
                    this.instanceError = false;
                    if (callback) {
                        callback();
                    }
                })
                .catch(() => {
                    this.instanceLoader = false;
                    this.instanceError = true;
                });
        },
        deleteImage(
            input,
            uploaded = input,
            arr = false,
            callback = false,
            index = false
        ) {
            if (arr) {
                arr.splice(index, 1);
                if (arr.length == 0) {
                    document.getElementById(input).value = "";
                }
            } else {
                document.getElementById(input).value = "";
                this[uploaded] = "";
            }
            this.errors.clear();
            this.$validator.reset();

            if (callback) {
                callback();
            }
        },
    },
};
